import React from "react";
import usePermission from "../hooks/usePermission";

type ModuleName =
  | "Dashboard"
  | "Notification Management"
  | "Manage Customer Support"
  | "Settings"
  | "Manage Customers"
  | "Manage Analytics"
  | "Manage CMS"
  | "Manage Subscriptions"
  | "Manage SubAdmin"
  | "Budget Intelligence"
  | "Document Processing"
  | "Hydration And Goal"
  | "Label Recognition"
  | "Location Intelligence"
  | "Manage Revenue"
  | "Shared Account"
  | "Shopping Meals"
  | "Translation Messaging"
  | "Reminder Engine"
  | "AI Behavior Language";

type Action = "view" | "add_edit" | "delete";

interface IfCanProps {
  module: ModuleName;
  action: Action;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const IfCan: React.FC<IfCanProps> = ({ module, action, children, fallback = null }) => {
  const { isLoading, canView, canAddEdit, canDelete } = usePermission({
    module,
    permission_type: "can_view",
  });

  if (isLoading) return null;

  let allowed = false;
  if (action === "view") allowed = canView(module);
  if (action === "add_edit") allowed = canAddEdit(module);
  if (action === "delete") allowed = canDelete(module);

  return <>{allowed ? children : fallback}</>;
};

export default IfCan;


